import Joi from 'joi';


const loginValidator = Joi.object({
    login: Joi.string()
        .min(3)
        .max(30)
        .required()
        .messages({
            'string.empty': 'Login is required',
            'string.min': 'Login must be at least 3 characters',
            'string.max': 'Login must not exceed 30 characters',
        }),
    password: Joi.string()
        .min(3)
        .required()
        .messages({
            'string.empty': 'Password is required',
            'string.min': 'Password must be at least 6 characters',
        }),
});

export {
    loginValidator
}
